import api from "../api/axiosInstance";

const emailTemplateService = {
    getAll: () => api.get("/email-templates"),
    getOne: (id) => api.get(`/email-templates/${id}`),
    update: (id, data) => api.patch(`/email-templates/${id}`, data),
};

export default emailTemplateService;